document.addEventListener("alpine:init", () => {
  Alpine.data("header", () => ({
    isFixed: false,
    mobileHeaderFixed: false,
    showMenuMobile: false,
    showMobileSearch: false,
    navigationHandler() {
      const element = document.querySelector("#header-middle");

      const addToCartButton = document.querySelector(
        "#primary-add-to-cart-btn",
      );
      if (addToCartButton) {
        if (
          window.scrollY >=
          addToCartButton.offsetTop + element.clientHeight
        ) {
          this.isFixed = true;
        } else {
          this.isFixed = false;
        }
      } else {
        if (window.scrollY >= element.offsetTop + element.clientHeight) {
          this.isFixed = true;
        } else {
          this.isFixed = false;
        }
      }
    },
    fixedHeaderHandler() {
      const element = document.querySelector("#header-top");
      const middlleEl = document.querySelector("#header-middle");
      if (window.scrollY > element.clientHeight) {
        this.mobileHeaderFixed = true;
        document.documentElement.style.setProperty(
          "--body-fixed-offset",
          middlleEl.clientHeight + "px",
        );
      } else {
        this.mobileHeaderFixed = false;
        document.documentElement.style.setProperty(
          "--body-fixed-offset",
          0 + "px",
        );
      }
    },
    init() {
      this.navigationHandler();
      this.fixedHeaderHandler();
      document.addEventListener("scroll", () => {
        this.navigationHandler();
        this.fixedHeaderHandler();
      });
    },
  }));
});
